<template>
  <div class="location-page">
    <!-- Hero sectie -->
    <div class="hero-section">
      <div class="container">
        <h1>Tandarts Vught | Tandzorg Gestel | Dichtbij Vught en Den Bosch</h1>
        <p class="lead">
          Zoekt u een <strong>tandarts in Vught</strong> of omgeving? Tandzorg Gestel in Sint-Michielsgestel 
          ligt op slechts 8 minuten van Vught centrum. Persoonlijke zorg, moderne technieken en 
          een warme, vertrouwde sfeer.
        </p>
      </div>
    </div>

    <div class="content-section">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <h2>Waarom Tandzorg Gestel voor patiënten uit Vught?</h2>
            <p>
              Inwoners van <em>Vught</em>, <em>Cromvoirt</em> en <em>Helvoirt</em> waarderen onze nabije locatie 
              in Sint-Michielsgestel. Slechts 8 minuten rijden van Vught centrum, maar met alle voordelen 
              van een kleinschalige, persoonlijke tandartspraktijk.
            </p>

            <h3>Voordelen voor Vughtse patiënten</h3>
            <ul class="benefits-list">
              <li><strong>Extra dichtbij</strong> - Slechts 8 minuten vanuit Vught centrum</li>
              <li><strong>Gratis parkeren</strong> - Ruime parkeerplaatsen direct voor de praktijk</li>
              <li><strong>Geen drukte</strong> - Rustige locatie, geen verkeersstress</li>
              <li><strong>Persoonlijke aandacht</strong> - Vaste behandelaar, alle tijd voor u</li>
              <li><strong>Flexibele tijden</strong> - Ook 's avonds en zaterdag geopend</li>
              <li><strong>Complete zorg</strong> - Alle behandelingen onder één dak</li>
            </ul>

            <h2>Route en bereikbaarheid vanuit Vught</h2>
            <div class="route-info">
              <h3>🚗 Met de auto vanuit Vught</h3>
              <ul>
                <li><strong>Vanuit Vught centrum:</strong> Via Helvoirtseweg richting Sint-Michielsgestel (8 min)</li>
                <li><strong>Vanuit Cromvoirt:</strong> Via Provincialeweg N65 naar Sint-Michielsgestel (12 min)</li>
                <li><strong>Vanuit Helvoirt:</strong> Via Bosscheweg richting Sint-Michielsgestel (10 min)</li>
                <li><strong>Vanuit Vught-Noord:</strong> Via A2 afslag Sint-Michielsgestel (6 min)</li>
              </ul>

              <h3>🚌 Openbaar vervoer vanuit Vught</h3>
              <ul>
                <li><strong>Bus lijn 20:</strong> Van Vught Station naar Sint-Michielsgestel (15 min)</li>
                <li><strong>Fiets:</strong> Via fietspad langs de Dommel (20 min)</li>
              </ul>
            </div>

            <h2>Tandheelkundige zorg voor Vught</h2>
            <p>
              Voor onze patiënten uit Vught bieden we het complete spectrum van tandheelkundige zorg, 
              van preventie tot specialistische behandelingen:
            </p>

            <div class="services-section">
              <div class="row">
                <div class="col-md-6">
                  <div class="service-card">
                    <h4>🦷 Algemene Tandheelkunde</h4>
                    <ul>
                      <li>Controles en reiniging</li>
                      <li>Vullingen en kronen</li>
                      <li>Tandtrekkingen</li>
                      <li>Spoedbehandelingen</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="service-card">
                    <h4>✨ Cosmetische Behandelingen</h4>
                    <ul>
                      <li>Tandenbleken (bleaching)</li>
                      <li>Veneers en facings</li>
                      <li>Composite bonding</li>
                      <li>Glimlach make-over</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="service-card">
                    <h4>🔬 Specialistische Zorg</h4>
                    <ul>
                      <li>Wortelkanaalbehandelingen</li>
                      <li>Parodontologie</li>
                      <li>Implantologie</li>
                      <li>Kaakchirurgie</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="service-card">
                    <h4>🧒 Kindertandheelkunde</h4>
                    <ul>
                      <li>Kindercontroles</li>
                      <li>Fluoridebehandelingen</li>
                      <li>Gebitsbegeleiding</li>
                      <li>Orthodontie</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <h2>Wat zeggen patiënten uit Vught?</h2>
            <div class="testimonials">
              <div class="testimonial">
                <div class="stars">★★★★★</div>
                <blockquote>
                  "Vanuit Vught ben ik overgestapt naar Tandzorg Gestel en wat een verschil! 
                  Persoonlijke aandacht, moderne praktijk en nog dichterbij ook."
                </blockquote>
                <cite>- M. van der Berg, Vught</cite>
              </div>
              
              <div class="testimonial">
                <div class="stars">★★★★★</div>
                <blockquote>
                  "Eindelijk een tandarts waar ze tijd voor je nemen. 
                  Vanuit Cromvoirt is het ook nog eens makkelijk te bereiken."
                </blockquote>
                <cite>- J. Peters, Cromvoirt</cite>
              </div>
            </div>

            <h2>Afspraak maken vanuit Vught</h2>
            <p>
              Het maken van een afspraak is eenvoudig. U kunt bellen, online een afspraak inplannen 
              of langs de praktijk komen. We staan klaar om u te helpen!
            </p>

            <div class="contact-methods">
              <div class="row">
                <div class="col-md-4">
                  <div class="contact-card">
                    <h4>📞 Telefonisch</h4>
                    <p>Bel ons tijdens kantooruren voor een afspraak of advies.</p>
                    <strong>073 - 551 4004</strong>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="contact-card">
                    <h4>💻 Online</h4>
                    <p>24/7 online afspraken maken via onze website.</p>
                    <router-link to="/afspraak-maken" class="btn-link">Afspraak Maken</router-link>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="contact-card">
                    <h4>🏥 Spoedgevallen</h4>
                    <p>Tandpijn of spoedgeval? We helpen u snel!</p>
                    <router-link to="/spoed" class="btn-link">Spoedhulp</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="sidebar">
              <div class="info-card">
                <h3>📍 Praktijk Informatie</h3>
                <p><strong>Adres:</strong><br>Dr. Erensstraat 45<br>5271 BC Sint-Michielsgestel</p>
                <p><strong>Afstand vanuit Vught:</strong><br>8 minuten rijden</p>
                <p><strong>Parkeren:</strong><br>Gratis voor de deur</p>
              </div>

              <div class="info-card">
                <h3>🕒 Openingstijden</h3>
                <ul class="opening-hours">
                  <li><strong>Maandag:</strong> 8:00 - 17:00</li>
                  <li><strong>Dinsdag:</strong> 8:00 - 20:00</li>
                  <li><strong>Woensdag:</strong> 8:00 - 17:00</li>
                  <li><strong>Donderdag:</strong> 8:00 - 20:00</li>
                  <li><strong>Vrijdag:</strong> 8:00 - 17:00</li>
                  <li><strong>Zaterdag:</strong> 9:00 - 13:00</li>
                </ul>
              </div>

              <div class="info-card">
                <h3>🎯 Waarom Wij?</h3>
                <ul class="why-us">
                  <li>✓ Lid van De Lieve Tandarts</li>
                  <li>✓ Moderne digitale technieken</li>
                  <li>✓ Ervaren specialisten</li>
                  <li>✓ Persoonlijke aandacht</li>
                  <li>✓ Alle leeftijden welkom</li>
                </ul>
              </div>

              <div class="cta-card">
                <h3>Klaar voor uw bezoek?</h3>
                <p>Maak vandaag nog een afspraak en ervaar het verschil van persoonlijke tandheelkundige zorg.</p>
                <router-link to="/afspraak-maken" class="btn-primary">Afspraak Maken</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TandartsVught',
  mounted() {
    document.title = 'Tandarts Vught | Tandzorg Gestel Sint-Michielsgestel | 8 Min Rijden'
    
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content', 
        'Tandarts Vught gezocht? Tandzorg Gestel in Sint-Michielsgestel ligt op 8 minuten van Vught. Persoonlijke zorg, gratis parkeren, moderne technieken. Nieuwe patiënten welkom!')
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]')
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 
        'tandarts Vught, tandarts 5261, tandarts Cromvoirt, tandarts Helvoirt, tandheelkunde Vught, Sint-Michielsgestel, Tandzorg Gestel')
    }
  }
}
</script>

<style scoped>
.location-page {
  padding-top: 120px;
}

.hero-section {
  background: linear-gradient(135deg, #e8f5e8 0%, #f0f8ff 100%);
  padding: 60px 0;
  margin-bottom: 40px;
}

.hero-section h1 {
  font-size: 2.5rem;
  color: var(--black);
  margin-bottom: 1rem;
  font-weight: 700;
}

.lead {
  font-size: 1.3rem;
  line-height: 1.6;
  color: var(--light-color);
}

.content-section {
  padding-bottom: 60px;
}

.benefits-list {
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 8px;
  border-left: 4px solid var(--blue);
}

.benefits-list li {
  margin-bottom: 0.8rem;
  color: var(--light-color);
}

.route-info {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  margin: 2rem 0;
}

.route-info h3 {
  color: var(--blue);
  margin-bottom: 1rem;
}

.services-section {
  margin: 3rem 0;
}

.service-card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  margin-bottom: 2rem;
  transition: transform 0.3s ease;
}

.service-card:hover {
  transform: translateY(-2px);
}

.service-card h4 {
  color: var(--blue);
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.service-card ul {
  list-style: none;
  padding: 0;
}

.service-card li {
  padding: 0.3rem 0;
  color: var(--light-color);
  position: relative;
  padding-left: 1rem;
}

.service-card li:before {
  content: "→";
  position: absolute;
  left: 0;
  color: var(--blue);
}

.testimonials {
  margin: 3rem 0;
}

.testimonial {
  background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
  padding: 2rem;
  border-radius: 12px;
  margin-bottom: 2rem;
  border-left: 4px solid var(--blue);
}

.stars {
  color: #ffc107;
  font-size: 1.2rem;
  margin-bottom: 1rem;
}

.testimonial blockquote {
  font-style: italic;
  margin: 1rem 0;
  color: var(--light-color);
  line-height: 1.6;
}

.testimonial cite {
  color: var(--blue);
  font-weight: 600;
  font-style: normal;
}

.contact-methods {
  margin: 3rem 0;
}

.contact-card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  text-align: center;
  margin-bottom: 2rem;
}

.contact-card h4 {
  color: var(--blue);
  margin-bottom: 1rem;
}

.btn-link {
  color: var(--blue);
  text-decoration: none;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border: 2px solid var(--blue);
  border-radius: 6px;
  transition: all 0.3s ease;
}

.btn-link:hover {
  background: var(--blue);
  color: white;
}

.sidebar {
  position: sticky;
  top: 120px;
}

.info-card,
.cta-card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  margin-bottom: 2rem;
}

.info-card h3,
.cta-card h3 {
  color: var(--blue);
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.opening-hours,
.why-us {
  list-style: none;
  padding: 0;
}

.opening-hours li,
.why-us li {
  padding: 0.3rem 0;
  color: var(--light-color);
  border-bottom: 1px solid #eee;
}

.opening-hours li:last-child,
.why-us li:last-child {
  border-bottom: none;
}

.cta-card {
  background: linear-gradient(135deg, var(--blue), var(--dark-blue));
  color: white;
  text-align: center;
}

.cta-card h3 {
  color: white;
}

.btn-primary {
  background: white;
  color: var(--blue);
  padding: 12px 24px;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  display: inline-block;
  margin-top: 1rem;
}

.btn-primary:hover {
  background: rgba(255,255,255,0.9);
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .location-page {
    padding-top: 100px;
  }
  
  .hero-section h1 {
    font-size: 2rem;
  }
  
  .hero-section {
    padding: 40px 0;
  }
  
  .route-info,
  .service-card,
  .contact-card {
    padding: 1.5rem;
  }
  
  .sidebar {
    position: static;
    margin-top: 3rem;
  }
}
</style>
